import type { ApiScopeBase } from '@ipfabric/utils';
import { plainSet } from '@ipfabric/utils/fp/plainSet';
import {
  type ApiScopeString,
  getApiScopeString,
} from 'components/GlobalState/selectors/selectApiScopeStringSet';
import { flow } from 'fp-ts/function';

export const isScopeAllowed: (
  apiScopeStringSet: Set<ApiScopeString>,
) => (scope: ApiScopeBase) => boolean = (
  apiScopeStringSet: Set<ApiScopeString>,
) => flow(getApiScopeString, plainSet.isInSet(apiScopeStringSet));
